import * as React from 'react';
import { useSelector } from 'react-redux';
import { Phones } from 'shared/components/HintQuestions/Phones';
import { getActualPhones } from 'shared/selectors';
import { formatNumber, getPhoneLink } from 'shared/utils/phone';

export const PhonesOpened = () => {
  const phones = useSelector(getActualPhones);

  const formattedPhones = React.useMemo(
    () =>
      phones.map(phone => ({
        number: formatNumber(phone),
        link: getPhoneLink(phone),
      })),
    [phones],
  );

  if (!phones.length || phones.some(phone => !phone.countryCode || !phone.number)) {
    return null;
  }

  return (
    <noindex>
      <Phones phones={formattedPhones} />
    </noindex>
  );
};
